import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutRoutingModule } from './about-routing.module';
import { AarniGroupComponent } from './aarni-group/aarni-group.component';
import { ActStatutesOrdinancesComponent } from './act-statutes-ordinances/act-statutes-ordinances.component';
import { InnovationAndEnterpreneurshipComponent } from './innovation-and-enterpreneurship/innovation-and-enterpreneurship.component';
import {ReactiveFormsModule} from "@angular/forms";
import { LeadershipComponent } from './leadership/leadership.component';


@NgModule({
  declarations: [
    AarniGroupComponent,
    InnovationAndEnterpreneurshipComponent,
    LeadershipComponent
  ],
    imports: [
        CommonModule,
        AboutRoutingModule,
        ActStatutesOrdinancesComponent,
        ReactiveFormsModule
    ]
})
export class AboutModule { }
